export var MoveStepsDirection;
(function (MoveStepsDirection) {
    MoveStepsDirection["TOP"] = "Top";
    MoveStepsDirection["ABOVE"] = "Above";
    MoveStepsDirection["BELOW"] = "Below";
    MoveStepsDirection["BOTTOM"] = "Bottom";
    MoveStepsDirection["CURSOR"] = "Cursor";
})(MoveStepsDirection || (MoveStepsDirection = {}));
export var CursorType;
(function (CursorType) {
    CursorType["STEP"] = "Step";
    CursorType["FLOW"] = "Flow";
})(CursorType || (CursorType = {}));
export var RecipeDisplayMode;
(function (RecipeDisplayMode) {
    RecipeDisplayMode["RECIPE_BUILDER"] = "recipeBuilder";
    RecipeDisplayMode["LIQUIDS_AND_GASES"] = "liquidsAndGases";
    RecipeDisplayMode["RECIPE_PARAMETERS"] = "recipeParameters";
    RecipeDisplayMode["CUSTOM_VARIABLES"] = "customVariables";
})(RecipeDisplayMode || (RecipeDisplayMode = {}));
export var RecipeBuilderActionMode;
(function (RecipeBuilderActionMode) {
    RecipeBuilderActionMode["PAN"] = "pan";
    RecipeBuilderActionMode["SELECT"] = "select";
})(RecipeBuilderActionMode || (RecipeBuilderActionMode = {}));
// Units;
export var NoUnitsType;
(function (NoUnitsType) {
    NoUnitsType["NoUnits"] = "NoUnits";
})(NoUnitsType || (NoUnitsType = {}));
export var CustomUnitType;
(function (CustomUnitType) {
    CustomUnitType["CustomUnits"] = "CustomUnits";
})(CustomUnitType || (CustomUnitType = {}));
export var TimeUnitsType;
(function (TimeUnitsType) {
    TimeUnitsType["Hr"] = "Hours";
    TimeUnitsType["Min"] = "Min";
    TimeUnitsType["S"] = "Sec";
})(TimeUnitsType || (TimeUnitsType = {}));
export var RateCoefficientsType;
(function (RateCoefficientsType) {
    RateCoefficientsType["Hr1"] = "PerHour";
    RateCoefficientsType["Min1"] = "PerMin";
    RateCoefficientsType["S1"] = "PerSec";
    RateCoefficientsType["Day1"] = "PerDay";
})(RateCoefficientsType || (RateCoefficientsType = {}));
export var RateChangeCoefficientsType;
(function (RateChangeCoefficientsType) {
    RateChangeCoefficientsType["Hr2"] = "PerHour2";
    RateChangeCoefficientsType["Min2"] = "PerMin2";
    RateChangeCoefficientsType["S2"] = "PerSec2";
})(RateChangeCoefficientsType || (RateChangeCoefficientsType = {}));
export var TemperatureUnitsType;
(function (TemperatureUnitsType) {
    TemperatureUnitsType["C"] = "Celsius";
    TemperatureUnitsType["F"] = "Fahrenheit";
})(TemperatureUnitsType || (TemperatureUnitsType = {}));
export var TemperatureChangeUnitsType;
(function (TemperatureChangeUnitsType) {
    TemperatureChangeUnitsType["Chr1"] = "CelsiusPerHour";
    TemperatureChangeUnitsType["Cmin1"] = "CelsiusPerMin";
    TemperatureChangeUnitsType["Fhr1"] = "FahrenheitPerHour";
    TemperatureChangeUnitsType["Fmin1"] = "FahrenheitPerMin";
})(TemperatureChangeUnitsType || (TemperatureChangeUnitsType = {}));
export var PHChangeUnitsType;
(function (PHChangeUnitsType) {
    PHChangeUnitsType["PHhr1"] = "PHPerHour";
})(PHChangeUnitsType || (PHChangeUnitsType = {}));
export var VolumeUnitsType;
(function (VolumeUnitsType) {
    VolumeUnitsType["MicroL"] = "Microliter";
    VolumeUnitsType["ML"] = "Milliliter";
    VolumeUnitsType["L"] = "Liter";
})(VolumeUnitsType || (VolumeUnitsType = {}));
export var PressureUnitsType;
(function (PressureUnitsType) {
    PressureUnitsType["MmHg"] = "MillimetreOfMercury";
})(PressureUnitsType || (PressureUnitsType = {}));
export var RateUnitsType;
(function (RateUnitsType) {
    RateUnitsType["MLmin1"] = "MilliliterPerMin";
    RateUnitsType["MLhr1"] = "MilliliterPerHour";
    RateUnitsType["Lmin1"] = "LiterPerMin";
    RateUnitsType["Lhr1"] = "LiterPerHour";
})(RateUnitsType || (RateUnitsType = {}));
export var SpecificRateUnitsType;
(function (SpecificRateUnitsType) {
    SpecificRateUnitsType["VVM"] = "VVM";
})(SpecificRateUnitsType || (SpecificRateUnitsType = {}));
export var RateChangeUnitsType;
(function (RateChangeUnitsType) {
    RateChangeUnitsType["MLmin2"] = "MilliliterPerMin2";
    RateChangeUnitsType["MLhr2"] = "MilliliterPerHour2";
    RateChangeUnitsType["Lmin2"] = "LiterPerMin2";
    RateChangeUnitsType["Lhr2"] = "LiterPerHour2";
})(RateChangeUnitsType || (RateChangeUnitsType = {}));
export var SpecificRateChangeUnitsType;
(function (SpecificRateChangeUnitsType) {
    SpecificRateChangeUnitsType["VVMhr1"] = "VVMPerHour";
})(SpecificRateChangeUnitsType || (SpecificRateChangeUnitsType = {}));
export var MassUnitsType;
(function (MassUnitsType) {
    MassUnitsType["Microg"] = "Microgram";
    MassUnitsType["Mg"] = "Miligram";
    MassUnitsType["G"] = "Gram";
})(MassUnitsType || (MassUnitsType = {}));
export var ConcentrationUnitsType;
(function (ConcentrationUnitsType) {
    ConcentrationUnitsType["MicrogL1"] = "MicrogramPerLiter";
    ConcentrationUnitsType["MgL1"] = "MiligramPerLiter";
    ConcentrationUnitsType["GL1"] = "GramPerLiter";
})(ConcentrationUnitsType || (ConcentrationUnitsType = {}));
export var InoculumConcentrationUnitsType;
(function (InoculumConcentrationUnitsType) {
    InoculumConcentrationUnitsType["MILLION_CELLS_PER_ML"] = "MillionCellsPerMl";
    InoculumConcentrationUnitsType["CELLS_PER_ML"] = "CellsPerMl";
})(InoculumConcentrationUnitsType || (InoculumConcentrationUnitsType = {}));
export var ConcentrationChangeUnitsType;
(function (ConcentrationChangeUnitsType) {
    ConcentrationChangeUnitsType["MicrogL1hr1"] = "MicrogramPerLiterPerHour";
    ConcentrationChangeUnitsType["MgL1hr1"] = "MiligramPerLiterPerHour";
    ConcentrationChangeUnitsType["GL1hr1"] = "GramPerLiterPerHour";
})(ConcentrationChangeUnitsType || (ConcentrationChangeUnitsType = {}));
export var PowerUnitsType;
(function (PowerUnitsType) {
    PowerUnitsType["W"] = "W";
    PowerUnitsType["KW"] = "KW";
})(PowerUnitsType || (PowerUnitsType = {}));
export var SpecificPowerUnitsType;
(function (SpecificPowerUnitsType) {
    SpecificPowerUnitsType["Wm3"] = "Wm3";
    SpecificPowerUnitsType["KWm3"] = "KWm3";
})(SpecificPowerUnitsType || (SpecificPowerUnitsType = {}));
export var StirringUnitsType;
(function (StirringUnitsType) {
    StirringUnitsType["Rpm"] = "Rpm";
    StirringUnitsType["Rps"] = "Rps";
})(StirringUnitsType || (StirringUnitsType = {}));
export var SpecificStirringUnitsType;
(function (SpecificStirringUnitsType) {
    SpecificStirringUnitsType["Rpmhr1"] = "RpmPerHour";
})(SpecificStirringUnitsType || (SpecificStirringUnitsType = {}));
export var PercentageUnitsType;
(function (PercentageUnitsType) {
    PercentageUnitsType["Percent"] = "Percent";
})(PercentageUnitsType || (PercentageUnitsType = {}));
export var VelocityUnitsType;
(function (VelocityUnitsType) {
    VelocityUnitsType["Mps"] = "Mps";
    VelocityUnitsType["Mpmin"] = "Mpmin";
    VelocityUnitsType["Cmps"] = "Cmps";
})(VelocityUnitsType || (VelocityUnitsType = {}));
// Steps;
export var RecipeStepType;
(function (RecipeStepType) {
    RecipeStepType["ALTERNATIVE"] = "Alternative";
    RecipeStepType["ADD_LIQUID"] = "AddLiquid";
    RecipeStepType["TAKE_SAMPLE"] = "TakeSample";
    RecipeStepType["BLEED"] = "Bleed";
    RecipeStepType["MEDIA_EXCHANGE"] = "MediaExchange";
    RecipeStepType["SET_DO"] = "SetDO";
    RecipeStepType["SET_PH"] = "SetPh";
    RecipeStepType["SET_TEMPERATURE"] = "SetTemperature";
    RecipeStepType["SET_DO_CONTROLLER"] = "SetDOController";
    RecipeStepType["SET_PH_CONTROLLER"] = "SetPhController";
    RecipeStepType["STIR_BIOREACTOR"] = "StirBioreactor";
    RecipeStepType["GAS_BIOREACTOR"] = "GasBioreactor";
    RecipeStepType["WAIT"] = "Wait";
    RecipeStepType["TIMESTAMP"] = "Timestamp";
    RecipeStepType["CONCURRENT"] = "Concurrent";
    RecipeStepType["CONDITIONAL"] = "Conditional";
    RecipeStepType["LOOP"] = "Loop";
})(RecipeStepType || (RecipeStepType = {}));
export var ComplexValueParameterType;
(function (ComplexValueParameterType) {
    ComplexValueParameterType["VALUES"] = "Values";
    ComplexValueParameterType["RELATIVE_VALUES"] = "RelativeValues";
    ComplexValueParameterType["PARAMETER"] = "Parameter";
    ComplexValueParameterType["ANY_UNIT_VALUE"] = "AnyUnitValue";
    ComplexValueParameterType["CUSTOM_VARIABLE"] = "CustomVariable";
    ComplexValueParameterType["INFINITE"] = "Infinite";
})(ComplexValueParameterType || (ComplexValueParameterType = {}));
export var OperationType;
(function (OperationType) {
    OperationType["MAINTAIN"] = "Maintain";
    OperationType["RAMP"] = "Ramp";
})(OperationType || (OperationType = {}));
export var DOControllerStepType;
(function (DOControllerStepType) {
    DOControllerStepType["STIR"] = "Stir";
    DOControllerStepType["GAS_SUPPLEMENT"] = "GasSupplement";
    DOControllerStepType["GAS_RATIO"] = "GasRatio";
    DOControllerStepType["UNKNOWN"] = "Unknown";
})(DOControllerStepType || (DOControllerStepType = {}));
export var BaseProcessFlowType;
(function (BaseProcessFlowType) {
    BaseProcessFlowType["CONSTANT_RATE"] = "ConstantRate";
    BaseProcessFlowType["RAMP"] = "Ramp";
})(BaseProcessFlowType || (BaseProcessFlowType = {}));
export var StirProcessFlowBasedOnType;
(function (StirProcessFlowBasedOnType) {
    StirProcessFlowBasedOnType["BASED_ON"] = "BasedOn";
})(StirProcessFlowBasedOnType || (StirProcessFlowBasedOnType = {}));
export var GasProcessFlowBasedOnType;
(function (GasProcessFlowBasedOnType) {
    GasProcessFlowBasedOnType["BASED_ON_KLA"] = "BasedOnKla";
})(GasProcessFlowBasedOnType || (GasProcessFlowBasedOnType = {}));
export var BasedOnType;
(function (BasedOnType) {
    BasedOnType["Kla"] = "Kla";
    BasedOnType["Ppv"] = "Ppv";
})(BasedOnType || (BasedOnType = {}));
export var WaitType;
(function (WaitType) {
    WaitType["FOR_TIME"] = "ForTime";
    WaitType["FOR_EVENT"] = "ForEvent";
})(WaitType || (WaitType = {}));
export var EventValueType;
(function (EventValueType) {
    EventValueType["REACHES"] = "Reaches";
    EventValueType["GOES_OVER"] = "GoesOver";
    EventValueType["GOES_UNDER"] = "GoesUnder";
    EventValueType["OUT_OF_RANGE"] = "OutOfRange";
    EventValueType["UNKNOWN"] = "Unknown";
})(EventValueType || (EventValueType = {}));
export var BleedType;
(function (BleedType) {
    BleedType["HOLD_CELL_DENSITY"] = "HoldCellDensity";
    BleedType["HOLD_VOLUME"] = "HoldVolume";
    BleedType["REMOVE_CELL_FREE_LIQUID"] = "RemoveCellFreeLiquid";
    BleedType["REMOVE_CELL_CONCENTRATED_LIQUID"] = "RemoveCellConcentratedLiquid";
})(BleedType || (BleedType = {}));
export var CellConcentratedLiquidType;
(function (CellConcentratedLiquidType) {
    CellConcentratedLiquidType["VOLUME"] = "Volume";
    CellConcentratedLiquidType["NUMBER_OF_CELLS"] = "NumberOfCells";
})(CellConcentratedLiquidType || (CellConcentratedLiquidType = {}));
export var TimeProfileType;
(function (TimeProfileType) {
    TimeProfileType["BOLUS"] = "Bolus";
    TimeProfileType["CONSTANT_RATE"] = "ConstantRate";
    TimeProfileType["RAMP"] = "Ramp";
})(TimeProfileType || (TimeProfileType = {}));
export var RateByType;
(function (RateByType) {
    RateByType["BY_RATE"] = "ByRate";
    RateByType["BY_TIME"] = "ByTime";
})(RateByType || (RateByType = {}));
export var TimeChangeType;
(function (TimeChangeType) {
    TimeChangeType["LINEAR"] = "Linear";
    TimeChangeType["EXPONENTIAL"] = "Exponential";
})(TimeChangeType || (TimeChangeType = {}));
export var RampType;
(function (RampType) {
    RampType["TOTAL_TIME"] = "TotalTime";
    RampType["END_RATE"] = "EndRate";
    RampType["RATE_CHANGE_COEFFICIENT"] = "RateChangeCoefficient";
})(RampType || (RampType = {}));
export var FeedType;
(function (FeedType) {
    FeedType["AMOUNT_CONSTITUENT"] = "AmountConstituent";
    FeedType["CONCENTRATION_CONSTITUENT"] = "ConcentrationConstituent";
    FeedType["MAINTAIN_CONSTITUENT"] = "MaintainConstituent";
    FeedType["CELL_DENSITY"] = "CellDensity";
    FeedType["VOLUME"] = "Volume";
    FeedType["TO_VOLUME"] = "ToVolume";
})(FeedType || (FeedType = {}));
export var FeedProcessType;
(function (FeedProcessType) {
    FeedProcessType["MAINTAIN"] = "Maintain";
    FeedProcessType["ACHIEVE"] = "Achieve";
})(FeedProcessType || (FeedProcessType = {}));
export var ConsumptionBasedType;
(function (ConsumptionBasedType) {
    ConsumptionBasedType["LINEAR_EXTRAPOLATION"] = "LinearExtrapolation";
    ConsumptionBasedType["CELL_DENSITY"] = "CellDensity";
})(ConsumptionBasedType || (ConsumptionBasedType = {}));
export var AddLiquidType;
(function (AddLiquidType) {
    AddLiquidType["FILL"] = "Fill";
    AddLiquidType["INOCULATION"] = "Inoculation";
    AddLiquidType["INDUCER"] = "Inducer";
    AddLiquidType["DILUTE"] = "Dilute";
    AddLiquidType["FEED"] = "Feed";
})(AddLiquidType || (AddLiquidType = {}));
export var DiluteType;
(function (DiluteType) {
    DiluteType["MAINTAIN"] = "Maintain";
    DiluteType["ACHIEVE"] = "Achieve";
})(DiluteType || (DiluteType = {}));
export var FillType;
(function (FillType) {
    FillType["FILL_TO"] = "FillTo";
    FillType["FILL_WITH"] = "FillWith";
})(FillType || (FillType = {}));
export var InducerType;
(function (InducerType) {
    InducerType["VOLUME"] = "Volume";
    InducerType["CURRENT_CELL_DENSITY"] = "CurrentCellDensity";
    InducerType["VOLUME_PER_CELL"] = "VolumePerCell";
})(InducerType || (InducerType = {}));
export var InoculationType;
(function (InoculationType) {
    InoculationType["TARGET_CELL_DENSITY"] = "TargetCellDensity";
    InoculationType["TARGET_VOLUME"] = "TargetVolume";
    InoculationType["VOLUME"] = "Volume";
})(InoculationType || (InoculationType = {}));
export var ConditionOperationType;
(function (ConditionOperationType) {
    ConditionOperationType["GREATER_THAN"] = "GreaterThan";
    ConditionOperationType["GREATER_THAN_OR_EQUAL"] = "GreaterThanOrEqual";
    ConditionOperationType["LESS_THAN"] = "LessThan";
    ConditionOperationType["LESS_THAN_OR_EQUAL"] = "LessThanOrEqual";
    ConditionOperationType["IN_RANGE"] = "InRange";
    ConditionOperationType["OUT_OF_RANGE"] = "OutOfRange";
})(ConditionOperationType || (ConditionOperationType = {}));
export var LoopConditionType;
(function (LoopConditionType) {
    LoopConditionType["AFTER_TIME"] = "AfterTime";
    LoopConditionType["CONDITION"] = "Condition";
    LoopConditionType["ITERATIONS_COUNT"] = "IterationsCount";
})(LoopConditionType || (LoopConditionType = {}));
export var PhControllerType;
(function (PhControllerType) {
    PhControllerType["PID"] = "PID";
    PhControllerType["BOLUS"] = "Bolus";
})(PhControllerType || (PhControllerType = {}));
export var InterventionType;
(function (InterventionType) {
    InterventionType["LIQUID"] = "Liquid";
    InterventionType["GAS"] = "Gas";
})(InterventionType || (InterventionType = {}));
export var SamplingType;
(function (SamplingType) {
    SamplingType["BY_VOLUME"] = "ByVolume";
    SamplingType["BY_CELLS_NUMBER"] = "ByCellsNumber";
})(SamplingType || (SamplingType = {}));
export var TakeSampleType;
(function (TakeSampleType) {
    TakeSampleType["VOLUME_REDUCTION"] = "VolumeReduction";
    TakeSampleType["SAMPLING"] = "Sampling";
})(TakeSampleType || (TakeSampleType = {}));
export var MediaExchangeType;
(function (MediaExchangeType) {
    MediaExchangeType["CELL_FREE_LIQUID"] = "CellFreeLiquid";
    MediaExchangeType["CELL_CONCENTRATED"] = "CellConcentrated";
})(MediaExchangeType || (MediaExchangeType = {}));
export var CellConcentratedExchangeType;
(function (CellConcentratedExchangeType) {
    CellConcentratedExchangeType["BY_VOLUME"] = "ByVolume";
    CellConcentratedExchangeType["BY_CELL_NUMBER"] = "ByCellNumber";
})(CellConcentratedExchangeType || (CellConcentratedExchangeType = {}));
// Gases
export var CommonGasType;
(function (CommonGasType) {
    CommonGasType["O2"] = "O2";
    CommonGasType["CO2"] = "CO2";
})(CommonGasType || (CommonGasType = {}));
export var GasType;
(function (GasType) {
    GasType["AIR"] = "Air";
    GasType["N2"] = "N2";
})(GasType || (GasType = {}));
export var ParameterTypesCategoryType;
(function (ParameterTypesCategoryType) {
    ParameterTypesCategoryType["NoUnits"] = "NoUnits";
    ParameterTypesCategoryType["UnitsOfTime"] = "UnitsOfTime";
    ParameterTypesCategoryType["CoefficientsOfRate"] = "CoefficientsOfRate";
    ParameterTypesCategoryType["CoefficientsOfRateChange"] = "CoefficientsOfRateChange";
    ParameterTypesCategoryType["UnitsOfTemperature"] = "UnitsOfTemperature";
    ParameterTypesCategoryType["UnitsOfTemperatureChange"] = "UnitsOfTemperatureChange";
    ParameterTypesCategoryType["UnitsOfPHChange"] = "UnitsOfPHChange";
    ParameterTypesCategoryType["UnitsOfVolume"] = "UnitsOfVolume";
    ParameterTypesCategoryType["UnitsOfPressure"] = "UnitsOfPressure";
    ParameterTypesCategoryType["UnitsOfRate"] = "UnitsOfRate";
    ParameterTypesCategoryType["UnitsOfRateChange"] = "UnitsOfRateChange";
    ParameterTypesCategoryType["UnitsOfSpecificRate"] = "UnitsOfSpecificRate";
    ParameterTypesCategoryType["UnitsOfSpecificRateChange"] = "UnitsOfSpecificRateChange";
    ParameterTypesCategoryType["UnitsOfMass"] = "UnitsOfMass";
    ParameterTypesCategoryType["UnitsOfInoculumConcentration"] = "UnitsOfInoculumConcentration";
    ParameterTypesCategoryType["UnitsOfConcentration"] = "UnitsOfConcentration";
    ParameterTypesCategoryType["UnitsOfConcentrationChange"] = "UnitsOfConcentrationChange";
    ParameterTypesCategoryType["UnitsOfPower"] = "UnitsOfPower";
    ParameterTypesCategoryType["UnitsOfSpecificPower"] = "UnitsOfSpecificPower";
    ParameterTypesCategoryType["UnitsOfStirring"] = "UnitsOfStirring";
    ParameterTypesCategoryType["UnitsOfStirringChange"] = "UnitsOfStirringChange";
    ParameterTypesCategoryType["UnitsOfPercentage"] = "UnitsOfPercentage";
    ParameterTypesCategoryType["UnitsOfVelocity"] = "UnitsOfVelocity";
    ParameterTypesCategoryType["Custom"] = "Custom";
})(ParameterTypesCategoryType || (ParameterTypesCategoryType = {}));
export var RecipeDialogType;
(function (RecipeDialogType) {
    RecipeDialogType["STEP"] = "step";
    RecipeDialogType["ALTERNATIVE_STEP"] = "alternativeStep";
    RecipeDialogType["CONDITIONAL_FLOW"] = "conditionalFlow";
    RecipeDialogType["GAS"] = "gas";
    RecipeDialogType["LIQUID"] = "liquid";
    RecipeDialogType["CUSTOM_VARIABLE"] = "customVariable";
})(RecipeDialogType || (RecipeDialogType = {}));
export var CustomVariableFormulaType;
(function (CustomVariableFormulaType) {
    CustomVariableFormulaType["Sum"] = "Sum";
    CustomVariableFormulaType["Difference"] = "Difference";
    CustomVariableFormulaType["Product"] = "Product";
    CustomVariableFormulaType["Quotient"] = "Quotient";
    CustomVariableFormulaType["Minimum"] = "Minimum";
    CustomVariableFormulaType["Maximum"] = "Maximum";
    CustomVariableFormulaType["Exponential"] = "Exponential";
    CustomVariableFormulaType["AbsoluteDifference"] = "AbsoluteDifference";
    CustomVariableFormulaType["ZScore"] = "ZScore";
    CustomVariableFormulaType["SaturationScore"] = "SaturationScore";
    CustomVariableFormulaType["LogisticScore"] = "LogisticScore";
    CustomVariableFormulaType["Value"] = "Value";
    CustomVariableFormulaType["LogBase10"] = "LogBase10";
    CustomVariableFormulaType["Ln"] = "Ln";
    CustomVariableFormulaType["Power"] = "Power";
})(CustomVariableFormulaType || (CustomVariableFormulaType = {}));
export var CustomVariableValueType;
(function (CustomVariableValueType) {
    CustomVariableValueType["Absolute"] = "Absolute";
    CustomVariableValueType["Relative"] = "Relative";
})(CustomVariableValueType || (CustomVariableValueType = {}));
export var CustomVariableRelativeValueType;
(function (CustomVariableRelativeValueType) {
    CustomVariableRelativeValueType["Variable"] = "Variable";
    CustomVariableRelativeValueType["Parameter"] = "Parameter";
})(CustomVariableRelativeValueType || (CustomVariableRelativeValueType = {}));
export var CustomVariableRelativeValueVariableType;
(function (CustomVariableRelativeValueVariableType) {
    CustomVariableRelativeValueVariableType["ProcessVariable"] = "ProcessVariable";
    CustomVariableRelativeValueVariableType["CustomVariable"] = "CustomVariable";
    CustomVariableRelativeValueVariableType["RecipeParameter"] = "RecipeParameter";
    CustomVariableRelativeValueVariableType["BioreactorParameter"] = "BioreactorParameter";
    CustomVariableRelativeValueVariableType["Unknown"] = "Unknown";
})(CustomVariableRelativeValueVariableType || (CustomVariableRelativeValueVariableType = {}));
export var CustomVariableTransformationTimestampHumanType;
(function (CustomVariableTransformationTimestampHumanType) {
    CustomVariableTransformationTimestampHumanType["CurrentTime"] = "CurrentTime";
    CustomVariableTransformationTimestampHumanType["Timestamp"] = "Timestamp";
})(CustomVariableTransformationTimestampHumanType || (CustomVariableTransformationTimestampHumanType = {}));
export var CustomVariableUnitFilterType;
(function (CustomVariableUnitFilterType) {
    CustomVariableUnitFilterType["All"] = "All";
    CustomVariableUnitFilterType["Regular"] = "Regular";
    CustomVariableUnitFilterType["Complex"] = "Complex";
})(CustomVariableUnitFilterType || (CustomVariableUnitFilterType = {}));
export var MoveFlowDirection;
(function (MoveFlowDirection) {
    MoveFlowDirection["LEFT"] = "Left";
    MoveFlowDirection["RIGHT"] = "Right";
})(MoveFlowDirection || (MoveFlowDirection = {}));
